export const cenScrollToFirstFormError = () => {
    const firstErrorElement = document.querySelector("[aria-invalid='true']");
    if (firstErrorElement) {
        const formFieldParent = firstErrorElement.closest("[class*='FormFieldStyle']");
        if (!formFieldParent) {
            return;
        }
        const { top } = formFieldParent.getBoundingClientRect();
        window.scrollTo({
            top: top + window.pageYOffset - 165.29,
            left: 0,
            behavior: "smooth",
        });
    }
};

export default cenScrollToFirstFormError;